import get from '../accessors/get';
import resolveScope from './#resolveScope';

export default function getScoped<State>(state: State, path: string, scope: string[]) {
  const propertyPath = resolveScope(path, scope);
  return get(state, propertyPath);
}
